import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import '../../styles/loginDesignTokens.css';

const websiteTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#488aec',
      light: '#6ba3f5',
      dark: '#3a6ec4',
    },
    text: {
      primary: '#0f172a',
      secondary: '#64748b',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F8FAFC',
    },
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", system-ui, -apple-system, sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
  },
});

export const WebsiteThemeProvider = ({ children }) => {
  // Ensure website always uses light mode by clearing any dark mode preferences
  React.useEffect(() => {
    try {
      // Remove theme mode from localStorage
      localStorage.removeItem('themeMode');
      localStorage.removeItem('adminThemeMode');
      
      // Ensure document is in light mode
      document.documentElement.removeAttribute('data-theme');
      document.body.removeAttribute('data-theme');
      
      // Set explicit light mode
      document.documentElement.setAttribute('data-theme', 'light');
    } catch (error) {
      console.warn('Error enforcing light mode:', error);
    }
  }, []);

  return (
    <ThemeProvider theme={websiteTheme}>
      {children}
    </ThemeProvider>
  );
}; 